import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import { BodyTextS } from "../Typography";

export const ChartWrapper = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        "& svg": { overflow: "visible" },
    }),
);

export const ChartCard = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        py: { md: 4 },
        px: { md: 5 },
    }),
);

export const LegendItem = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        position: "relative",
        pl: 5,
        py: 2,
        "& .MuiTypography-root": { mb: 0 },
        "&:before": {
            position: "absolute",
            top: 6,
            left: 0,
            display: "block",
            width: 16,
            height: 16,
            borderRadius: 1,
            background: "var(--legend-color)",
            content: "''",
        },
    }),
);

export const ValueSpan = styled("span")(({ theme }) => theme.unstable_sx({ pl: 3 }));

export const LegendRow = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        justifyContent: "space-between",
    }),
);

export const TooltipBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        bgcolor: "background.paper",
        p: 2,
        border: 1,
        borderColor: "grey.300",
        borderRadius: 1,
    }),
);

export const TooltipDateText = styled(BodyTextS)(({ theme }) =>
    theme.unstable_sx({
        mb: 1,
    }),
);

export const TooltipValueText = styled(BodyTextS, {
    shouldForwardProp: (prop) => prop !== "itemColor",
})<{ itemColor: string }>(({ itemColor, theme }) =>
    theme.unstable_sx({
        mb: 0,
        color: itemColor,
    }),
);

export const SkeletonChart = styled(Skeleton)({
    height: 350,
});
